var $3f165936910f27a7$exports = {};
$3f165936910f27a7$exports = {
    "endTime": `Terminar tempo`,
    "startTime": `Iniciar tempo`,
    "time": `Tempo`
};


export {$3f165936910f27a7$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
